'use client'
import classnames from 'classnames'
import ArticleCardList from '@dustin-web/content-components/src/article-card-list'
import Icon from '@dustin-web/microsite-components/src/icon'
import { getKnowledgeBankUrl } from '@dustin-web/microsite-config'
import type { GetArticleBoxListQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import Button from '@dustin-web/microsite-components/src/button'
import { useTrackingOnScreen } from '@dustin-web/microsite-components/src/on-screen/'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'

export type KnowledgeBankProps = {
  data: GetArticleBoxListQuery
  showAllText: string
  title?: string
  removeTopPadding?: boolean
  removeBottomPadding?: boolean
  showFourCardsPerRow?: boolean
  showAllBtnView?: boolean
  trackingID?: string
}

const caseStudiesOnClick = (trackingID: string) => {
  DigitalData.pushSelectPromotion({
    creative_name: trackingID,
    promotion_name: '',
    creative_slot: '',
    promotion_id: '',
  })
}

const caseStudiesView = (trackingID: string) => {
  DigitalData.pushViewPromotion({
    creative_name: trackingID,
    promotion_name: '',
    creative_slot: '',
    promotion_id: '',
  })
}

const getArticleCardListProps = (data: GetArticleBoxListQuery) => {
  const blogUrl = data?.articleBoxList?.blogUrl ?? ''
  let articlesList = data?.articleBoxList?.articles ?? []
  if (articlesList.length) {
    articlesList = articlesList.map(({ postDateText, ...rest }) => {
      return { postDateText: '', ...rest }
    })
  }

  return {
    articlesList,
    blogUrl,
    hideCategoryName: true,
  }
}

export const KnowledgeBank = ({
  data,
  showAllText,
  title,
  removeTopPadding = false,
  removeBottomPadding = false,
  showFourCardsPerRow = false,
  showAllBtnView = false,
  trackingID,
}: KnowledgeBankProps) => {
  const ref = useTrackingOnScreen(() => {
    if (trackingID) {
      caseStudiesView(trackingID)
    }
  })
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()

  const articleCardListProps = getArticleCardListProps(data)

  return (
    <div
      className={classnames({ 'u-pt-32': !removeTopPadding }, { 'u-pb-32': !removeBottomPadding })}>
      <div className="container">
        {title ? <h2 className="u-mb-16">{title}</h2> : null}
        <ArticleCardList
          {...articleCardListProps}
          showFourCardsPerRow={showFourCardsPerRow}
          onCardClick={trackingID ? () => caseStudiesOnClick(trackingID) : undefined}
        />
        <div ref={ref} className="d-flex justify-content-end u-mt-16">
          {showAllBtnView ? (
            <Button
              link
              href={getKnowledgeBankUrl(sourcingCompany)}
              text={showAllText}
              icon="arrow-right"
            />
          ) : (
            <a
              className="d-flex"
              aria-label={translate('To_The_Knowledge_Bank')}
              href={getKnowledgeBankUrl(sourcingCompany)}>
              <span className="u-mr-8">{showAllText}</span>
              <Icon name="arrow-right" className="i-16 u-ml-4" />
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
